import React from 'react';
import { FiCheck, FiActivity, FiClock } from 'react-icons/fi';

const RecentActivity = () => {
  // Timeline events array matching your image's exact text data strings
  const events = [
    {
      id: 1,
      title: "Temperature normal",
      desc: "2.4°C",
      time: "18 sec ago",
      icon: FiCheck,
      iconColor: "bg-blue-50 text-blue-500 border-blue-100"
    },
    {
      id: 2,
      title: "Normal fluctuation detected",
      desc: "2.7°C → 2.3°C",
      time: "12:45",
      icon: FiActivity,
      iconColor: "bg-blue-50 text-blue-400 border-blue-100"
    },
    {
      id: 3,
      title: "Temperature normal",
      desc: "2.5°C",
      time: "11:30",
      icon: FiActivity,
      iconColor: "bg-emerald-50 text-emerald-500 border-emerald-100"
    },
    {
      id: 4,
      title: "Normal fluctuation detected",
      desc: "3.1°C → 2.4°C",
      time: "09:15",
      icon: FiActivity,
      iconColor: "bg-emerald-50 text-emerald-500 border-emerald-100"
    },
    {
      id: 5,
      title: "Temperature normal",
      desc: "2.4°C",
      time: "07:45",
      icon: FiActivity,
      iconColor: "bg-emerald-50 text-emerald-500 border-emerald-100"
    }
  ];

  return (
    <div className="w-full max-w-md bg-white border border-gray-100 rounded-2xl p-5 font-sans shadow-[0_2px_12px_rgba(0,0,0,0.01)] select-none">
      {/* Header */}
      <h3 className="text-[15px] font-bold text-gray-800 tracking-tight mb-6">
        Recent Activity (Today)
      </h3>

      {/* Vertical Timeline Stack */}
      <div className="relative pl-6 space-y-6">
        {/* Main continuous vertical timeline line link guide */}
        <div className="absolute left-[9px] top-2 bottom-2 w-[1px] bg-gray-100"></div>

        {events.map((event) => {
          const ItemIcon = event.icon;
          return (
            <div key={event.id} className="relative flex items-start justify-between gap-4 group">
              
              {/* Outer timeline checking marker dot node */}
              <div className="absolute -left-[23px] top-1.5 w-4 h-4 bg-white border border-emerald-500 rounded-full flex items-center justify-center shadow-xs z-10">
                <FiCheck className="w-2.5 h-2.5 text-emerald-600 stroke-[3]" />
              </div>

              {/* Event Content Segment Row */}
              <div className="flex gap-3 min-w-0">
                {/* Embedded status icon box */}
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${event.iconColor}`}>
                  <ItemIcon className="w-4 h-4" />
                </div>
                
                <div className="space-y-0.5 min-w-0">
                  <p className="text-[13px] font-bold text-gray-800 truncate leading-none">
                    {event.title}
                  </p>
                  <p className="text-[12px] font-extrabold text-slate-500">
                    {event.desc}
                  </p>
                </div>
              </div>

              {/* Timestamp Meta text alignment */}
              <span className="text-[11px] font-bold text-gray-400 shrink-0 text-right pt-0.5 whitespace-nowrap">
                {event.time}
              </span>

            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentActivity;
